import { authApi } from "../../../../api-calls/user-requests";
import { TEAM_LIST } from "../../../../api-calls/api-urls";

export const GEOFENCE_MIN_RADIUS = 100;
export const GEOFENCE_MAX_RADIUS = 1000;
export const GEOFENCE_RADIUS_STEP = 50;
export const GEOFENCE_DEFAULT_RADIUS = 500;

export const GEOFENCE_MODES = [
  { value: "time_in", label: "Time In Only" },
  { value: "time_in_out", label: "Time In & Time Out" },
];
export const modeLabel = (mode) =>
  mode === "time_in" ? "Time In Only" : "Time In & Time Out";

// Must match every other useJsApiLoader call in the app (same id => same options).
export const MAPS_LOADER_ID = "google-map-script";
export const MAPS_LIBRARIES = ["places"];

// Design tokens from the mobile Geo Fencing screens.
export const GF = {
  primary: "#256FE8",
  primaryTint: "rgba(37,111,232,0.12)",
  foreground: "#282C34",
  muted: "#6B7280",
  border: "#E5E7EB",
  field: "#EFEFF1",
  destructive: "#EB4242",
  destructiveTint: "#FCE5E5",
  success: "#2EB88A",
  successTint: "#DEF5EB",
};

export const CIRCLE_OPTIONS = {
  strokeColor: GF.primary,
  strokeOpacity: 0.9,
  strokeWeight: 2,
  fillColor: GF.primary,
  fillOpacity: 0.18,
  clickable: false,
};

export const clampRadius = (value) =>
  Math.min(
    GEOFENCE_MAX_RADIUS,
    Math.max(
      GEOFENCE_MIN_RADIUS,
      Math.round(Number(value) / GEOFENCE_RADIUS_STEP) * GEOFENCE_RADIUS_STEP
    )
  );

/** "500 m" / "1 km" */
export const formatRadius = (meters) =>
  meters >= 1000 ? `${+(meters / 1000).toFixed(1)} km` : `${meters} m`;

/** Short place label ("Patia, Bhubaneswar"). */
export const placeLabel = (g) =>
  g?.name || (g?.address || "").split(",").slice(0, 2).join(",").trim() || "";

/** True when a team (from POST /teams/:slug) has a geofence configured. */
export const hasGeofence = (team) =>
  Number.isFinite(team?.geofence?.lat) &&
  Number.isFinite(team?.geofence?.lng) &&
  !!team?.geofence?.radius_meters;

/** Zoom/pan a Google Map so the whole geofence circle is visible. */
export const fitMapToCircle = (map, center, radius) => {
  if (!map || !window.google?.maps) return;
  const circle = new window.google.maps.Circle({ center, radius });
  map.fitBounds(circle.getBounds());
};

/** Team details (with members + department_data) by slug. */
export const fetchTeamBySlug = async (slug) => {
  const { data } = await authApi.post(
    `${TEAM_LIST}/${slug}?search=&sortBy=oldest_to_newest`,
    { status: [] }
  );
  return data;
};

export const fetchTeamGeofence = async (teamId) => {
  const { data } = await authApi.get(`${TEAM_LIST}/${teamId}/geofence`);
  return data.geofence;
};

/** Create or edit; a partial body only changes the fields it carries. */
export const saveTeamGeofence = async (teamId, input) => {
  const { data } = await authApi.put(`${TEAM_LIST}/${teamId}/geofence`, input);
  return data.geofence;
};

export const removeTeamGeofence = async (teamId) => {
  await authApi.delete(`${TEAM_LIST}/${teamId}/geofence`);
};

export const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback;
